<p>
    You entered details in this response that differ from the saved merchant profile for
    <strong>{{ data.merchantName }}</strong>.
</p>
<p>Would you like to update the merchant profile with the following changes?</p>
<ul>
    <ol *ngFor="let change of data.changes">
        <strong>{{ change.label }}</strong><br/>
        "{{ change.from || '-' }}" → "{{ change.to || '-' }}"
    </ol>
</ul>
<p>
    <small>
        <i>Note: Updating the merchant profile will not affect other assessments that have already been started.</i>
    </small>
</p>